import {foundationTheme, getColorByPath, type ThemeColorPath} from 'platform/foundation';

import {CHART_PALETTE} from './CHART_PALETTE';

// A missing token prints black, so the gap shows instead of a silently wrong hue.
const MISSING_TOKEN_COLOR = '#000000';

const resolve = (color: ThemeColorPath) =>
  getColorByPath(color, foundationTheme) ?? MISSING_TOKEN_COLOR;

/**
 * The series colours as hex values for print documents, such as the PDF export, which render
 * outside the theme. They come from the same tokens as the charts on screen.
 */
export const CHART_PRINT_COLORS = {
  blue: resolve(CHART_PALETTE.blue.base),
  green: resolve(CHART_PALETTE.green.base),
  orange: resolve(CHART_PALETTE.orange.base),
  purple: resolve(CHART_PALETTE.purple.base),
  // Status and age colours outside the categorical palette, as the warehouse charts use them.
  lightOrange: resolve('palettes.orange.60.100'),
  red: resolve('palettes.red.60.100'),
} as const;
